module.exports = __webpack_public_path__ + "static/media/P648_0.5297bda6.jpeg";